// ErrorBoundary genérico — captura erro de renderização e mostra detalhes
// em vez de tela branca. Ajuda muito a diagnosticar bug em produção, onde
// o gerente/vendedora não abre DevTools.
//
// Uso:
//   <ErrorBoundary onde="OrderDetail">
//     <OrderDetail />
//   </ErrorBoundary>

import { Component } from 'react'
import { AlertCircle, RefreshCw, Copy } from 'lucide-react'

export class ErrorBoundary extends Component {
  constructor(props) {
    super(props)
    this.state = { erro: null, stack: null }
  }
  static getDerivedStateFromError(erro) {
    return { erro, stack: erro?.stack || null }
  }
  componentDidCatch(erro, info) {
    // Loga no console pra ficar disponível no DevTools tb
    // eslint-disable-next-line no-console
    console.error('[ErrorBoundary]', this.props.onde || 'desconhecido', erro, info)
  }
  copiarDetalhes = () => {
    const txt = [
      `Onde: ${this.props.onde || 'desconhecido'}`,
      `URL: ${window.location.href}`,
      `Erro: ${this.state.erro?.message || this.state.erro}`,
      ``,
      `Stack:`,
      this.state.stack || '(sem stack)',
    ].join('\n')
    navigator.clipboard.writeText(txt).then(() => alert('Detalhes copiados — cole no chat')).catch(() => {})
  }
  recarregar = () => {
    window.location.reload()
  }
  render() {
    if (!this.state.erro) return this.props.children
    return (
      <div className="max-w-2xl mx-auto px-4 py-8">
        <div className="card p-6 border-2 border-red-200 bg-red-50/30">
          <div className="flex items-start gap-3 mb-4">
            <AlertCircle size={24} className="text-red-600 shrink-0 mt-0.5" />
            <div className="flex-1">
              <h1 className="text-lg font-bold text-red-700">Algo deu errado nesta tela</h1>
              <p className="text-sm text-slate-600 mt-1">
                Não foi possível carregar. Os dados não foram perdidos — você pode voltar e tentar de novo.
              </p>
            </div>
          </div>

          <div className="bg-white border border-red-200 rounded-lg p-3 mb-4">
            <p className="text-xs uppercase font-bold text-slate-400 mb-1">Mensagem técnica</p>
            <p className="text-sm font-mono text-red-700 break-all">
              {this.state.erro?.message || String(this.state.erro)}
            </p>
          </div>

          <div className="flex flex-wrap gap-2">
            <button onClick={this.recarregar} className="btn-primary text-sm">
              <RefreshCw size={14} />
              Recarregar
            </button>
            <button onClick={this.copiarDetalhes} className="btn-secondary text-sm">
              <Copy size={14} />
              Copiar detalhes do erro
            </button>
            <button onClick={() => window.history.back()} className="btn-secondary text-sm">
              ← Voltar
            </button>
          </div>

          <p className="text-xs text-slate-400 mt-4 leading-relaxed">
            Clique em <strong>"Copiar detalhes"</strong> e cole no chat — assim eu consigo ver
            exatamente o que quebrou e arrumar rápido.
          </p>
        </div>
      </div>
    )
  }
}
